import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function VidikovacIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="VidikovacIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <polygon fill="#FFFFFF" points="47.4,88 45,87.1 42.8,85.4 41,83.3 40.1,80.9 39.6,78.4 39.8,75.9 40.6,72.6 38.9,75.4 37.4,77.2 
	35.2,78.9 32.7,79.8 30.2,80.2 27.4,79.8 25,78.8 22.8,77.2 21.3,75.1 20.2,72.5 19.8,69.9 20.1,67.3 21,64.8 22.7,62.6 24.6,61.1 
	27.4,59.4 24.1,60.2 21.7,60.4 19.2,60 16.7,59 14.6,57.3 13,55.1 11.9,52.7 11.6,50.1 11.9,47.4 12.9,45 14.5,42.8 16.7,41.1 
	19.1,40.1 21.8,39.6 24.2,39.9 27.6,40.7 24.6,38.9 22.8,37.4 21,35.2 20.2,32.7 19.8,30.2 20.2,27.4 21.2,25 22.8,22.9 24.9,21.3 
	27.4,20.2 30.1,19.8 32.7,20.2 35.1,21.1 37.4,22.7 38.9,24.6 40.6,27.4 39.8,24.2 39.6,21.7 40.1,19.2 41,16.7 42.7,14.6 44.9,13 
	47.3,12 49.9,11.6 52.6,12 55,12.9 57.2,14.6 58.9,16.7 59.9,19.1 60.4,21.7 60.2,24.1 59.4,27.5 61.1,24.6 62.6,22.7 64.8,21.2 
	67.2,20.2 69.8,19.8 72.6,20.2 75,21.3 77.1,22.9 78.7,24.9 79.8,27.4 80.2,30.1 79.8,32.8 78.9,35.1 77.3,37.4 75.4,38.9 
	72.4,40.7 75.8,39.9 78.2,39.6 80.8,40.1 83.3,41 85.4,42.7 87,44.9 88.1,47.4 88.4,50 88,52.6 87.1,55 85.4,57.2 83.3,58.9 
	80.9,59.9 78.3,60.4 75.9,60.2 72.6,59.4 75.4,61.1 77.3,62.6 78.8,64.8 79.8,67.2 80.2,69.8 79.8,72.5 78.7,75.1 77.1,77.2 
	75,78.7 72.6,79.8 69.9,80.2 67.3,79.8 64.8,78.9 62.6,77.3 61.1,75.4 59.4,72.6 60.2,75.8 60.4,78.2 59.9,80.8 58.9,83.3 
	57.3,85.4 55.1,87 52.7,88 50,88.4 "/>
      <path fill="#FF0000" d="M46.1,51l-22.6,5.4l-1.7,0.1l-1.7-0.3l-1.5-0.6l-1.3-1l-1-1.4l-0.6-1.5L15.5,50l0.2-1.7l0.6-1.5l1-1.4l1.3-1
	l1.5-0.6l1.7-0.3l1.7,0.2L46.1,49V51L46.1,51z M46.6,47.9L26.8,35.7l-1.3-1l-1-1.4l-0.6-1.5l-0.2-1.7l0.2-1.7l0.7-1.5l1-1.3l1.4-1
	l1.5-0.7l1.7-0.2l1.7,0.2l1.5,0.6l1.4,1l1,1.3l12.1,19.7L46.6,47.9z M47.9,53.5L35.7,73.2l-1,1.3l-1.4,1l-1.5,0.6l-1.7,0.2l-1.7-0.2
	l-1.6-0.7l-1.3-1l-1-1.3l-0.7-1.6l-0.2-1.7l0.2-1.7l0.6-1.5l1-1.4l1.3-1l19.7-12.1L47.9,53.5z M49,46.1l-5.4-22.6l-0.1-1.7l0.3-1.7
	l0.6-1.5l1-1.3l1.4-1l1.5-0.6l1.7-0.2l1.7,0.2l1.5,0.6l1.4,1l1,1.3l0.6,1.5l0.3,1.7l-0.1,1.7L51,46.1H49z M51,53.9l5.4,22.6l0.1,1.7
	l-0.3,1.7l-0.6,1.5l-1,1.3l-1.4,1l-1.5,0.6L50,84.5l-1.7-0.2l-1.5-0.6l-1.4-1l-1-1.3l-0.6-1.5l-0.3-1.7l0.1-1.7L49,53.9H51z
	 M52.1,46.6l12.1-19.7l1-1.3l1.4-1l1.5-0.6l1.7-0.2l1.7,0.2l1.5,0.7l1.3,1l1,1.3l0.7,1.5l0.2,1.7L76,31.9l-0.6,1.5l-1,1.4l-1.3,1
	L53.4,47.9L52.1,46.6z M53.4,52.1l19.7,12.1l1.3,1l1,1.4l0.6,1.5l0.2,1.7L76,71.5l-0.7,1.6l-1,1.3l-1.3,1l-1.5,0.7l-1.7,0.2
	l-1.7-0.2l-1.5-0.6l-1.4-1l-1-1.3L52.1,53.5L53.4,52.1z M53.9,49l22.6-5.3l1.7-0.2l1.7,0.3l1.5,0.6l1.3,1l1,1.4l0.6,1.5l0.2,1.7
	l-0.2,1.7l-0.6,1.5l-1,1.4l-1.3,1l-1.5,0.6l-1.7,0.3l-1.7-0.1L53.9,51V49z"/>
    </svg>
  </SvgIcon>
}

export default VidikovacIcon;
